import { BooleanInput } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  Component,
  booleanAttribute,
  inject,
  input,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { ClipboardService } from '../../services/clipboard.service';

@Component({
  selector: 'procure-copy-button',
  templateUrl: './copy-button.component.html',
  styleUrl: './copy-button.component.scss',
  imports: [MatTooltip, MatIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyButton {
  readonly value = input<string | null>();
  readonly tooltip = input<string | null>();

  readonly isUrl = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  private readonly clipboardService = inject(ClipboardService);

  protected copy(): void {
    const value = this.value();
    const isUrl = this.isUrl();

    if (!value && !isUrl) {
      return;
    }

    if (isUrl) {
      this.clipboardService.copy(value ?? '', true);
    } else if (value) {
      this.clipboardService.copy(value);
    }
  }
}
